<template>
  <popup
    v-model="visibleValue"
    class="kk-confirm"
    v-bind="allProps"
    position="center"
    @click-overlay="onClickOverlayHandler"
  >
    <div class="confirm-content">
      <div class="confirm-content-text">
        <slot
          v-if="title"
          name="title"
        >
          <div class="confirm-title">
            {{ title }}
            <slot name="close">
              <span
                class="title-close"
                @click="onClickButtonHandler('cancel')"
              />
            </slot>
          </div>
        </slot>
        <div
          v-if="headerImage"
          class="confirm-content-header"
        >
          <img :src="headerImage">
        </div>
        <slot name="default">
          <span class="confirm-text">{{ text }}</span>
        </slot>
        <slot name="description">
          <span class="confirm-description">{{ description }}</span>
        </slot>
      </div>
    </div>
    <slot
      v-if="!hideConfirmBtn&&!hideConfirmBtn"
      name="line"
    >
      <div class="confirm-line" />
    </slot>
    <div
      v-if="!hideConfirmBtn&&!hideConfirmBtn"
      :class="{
        'confirm-control': true,
        'list-status': buttonList.length > 0,
      }"
    >
      <template v-if="!buttonList.length">
        <slot
          v-if="!hideCancelBtn"
          name="cancel-button"
        >
          <kk-button
            ref="cancel-btn"
            size="xs"
            width="68px"
            :disabled="cancelDisabled"
            class="confirm-control-btn"
            @click="onClickButtonHandler('cancel')"
          >
            {{ cancelText }}
          </kk-button>
        </slot>
        <slot
          v-if="!hideConfirmBtn"
          name="confirm-button"
        >
          <kk-button
            ref="confirm-btn"
            type="primary"
            size="xs"
            width="68px"
            class="confirm-control-btn"
            :disabled="confirmDisabled"
            @click="onClickButtonHandler('confirm')"
          >
            {{ confirmText }}
          </kk-button>
        </slot>
      </template>
      <template v-else>
        <slot name="button-list">
          <kk-button
            v-for="(item, index) in buttonList"
            :key="index"
            :ref="`btn-item-${index}`"
            class="confirm-control-btn"
            :disabled="item.disabled"
            size="xs"
            width="68px"
            :type="item.type"
            @click="onListButtonClickHandler(index)"
          >
            {{ item.text }}
          </kk-button>
        </slot>
      </template>
    </div>
  </popup>
</template>

<script lang="ts">
import { Options, Vue, Prop } from 'vue-property-decorator';
import popup from '../popup/index.vue';
import { IButton } from './typings';
import KkButton from '@/component/kk-button/index.vue';

@Options({
  name: 'KkConfirm',
  inheritAttrs: false,
  emits: [
    'update:modelValue',
    'confirm',
    'cancel',
    'clickButton',
  ],
  components: {
    popup,
    KkButton,
  },
})
export default class KkConfirm extends Vue {
  @Prop({ default: false }) readonly modelValue: boolean;
  @Prop({ default: '' }) readonly title: string;
  @Prop({ default: '' }) readonly text: string;
  @Prop({ default: '' }) readonly description: string;
  @Prop({ default: '' }) readonly headerImage: string;
  @Prop({ default: '取消' }) readonly cancelText: string;
  @Prop({ default: '确定' }) readonly confirmText: string;
  @Prop({ default: '' }) readonly cancelColor: string;
  @Prop({ default: '' }) readonly confirmColor: string;
  @Prop({ default: false }) readonly cancelDisabled: boolean;
  @Prop({ default: false }) readonly confirmDisabled: boolean;
  @Prop({ default: false }) readonly hideCancelBtn: boolean;
  @Prop({ default: false }) readonly hideConfirmBtn: boolean;
  @Prop({ default: () => [] }) readonly buttonList: Array<IButton>;

  get visibleValue() {
    return this.modelValue;
  }

  set visibleValue(value: boolean) {
    this.$emit('update:modelValue', value);
  }

  get allProps(): Record<string, unknown> {
    return {
      ...this.$attrs,
      ...this.$props,
    };
  }

  onClickButtonHandler(btnType: string): void {
    if (btnType === 'confirm' && !this.confirmDisabled) {
      this.visibleValue = !this.visibleValue;
      this.$emit('confirm');
    }
    if (btnType === 'cancel' && !this.cancelDisabled) {
      this.visibleValue = !this.visibleValue;
      this.$emit('cancel');
    }
  }

  onClickOverlayHandler(): void {
    this.$emit('cancel');
  }

  onListButtonClickHandler(index: number): void {
    const button = this.buttonList[index];
    if (!button?.disabled) {
      this.visibleValue = !this.visibleValue;
      this.$emit('clickButton', index);
    }
  }
}
</script>

<style lang="scss" src="./index.scss"></style>
